import { Grid, Button } from '@razz-team/ui-web';
import { useTranslation } from 'react-i18next';
import { MainLayout } from '../../Layout/MainLayout';
import { useHasRole } from '../../../api/access';
import { MembersIsland } from '../BusinessPage/Member/MembersIsland';

export function MembersPage() {
  const { t } = useTranslation();
  const isOwner = useHasRole('OWNER');

  return (
    <MainLayout
      title={t('Linked members')}
      actions={
        isOwner ? (
          <Button variant="contained" href="/account/business/add-member">
            {t('Add member')}
          </Button>
        ) : undefined
      }
    >
      <Grid size={12}>
        <MembersIsland isSearchEnabled />
      </Grid>
    </MainLayout>
  );
}
